import { useEffect, useMemo, useState } from 'react';

const getViewportWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 1920);

export const getMaxVisibleButtons = (width) => {
  if (width <= 575.98) return 2;
  if (width <= 767.98) return 4;
  if (width <= 991.98) return 5;
  if (width <= 1199.98) return 6;
  return Number.MAX_SAFE_INTEGER;
};

const useFloatingMenuVisibility = (buttons = []) => {
  const [viewportWidth, setViewportWidth] = useState(getViewportWidth());

  useEffect(() => {
    const handleResize = () => setViewportWidth(getViewportWidth());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const visibleButtons = useMemo(() => buttons.filter((button) => !button.hide), [buttons]);
  const maxVisibleButtons = getMaxVisibleButtons(viewportWidth);
  const visibleCountOnScreen = Math.min(visibleButtons.length, maxVisibleButtons);
  const showMoreMenu = visibleButtons.length > maxVisibleButtons;

  return {
    visibleButtons,
    maxVisibleButtons,
    visibleCountOnScreen,
    showMoreMenu
  };
};

export default useFloatingMenuVisibility;
